import { getLeaderSquare } from "@/lib/getLeaderImage";
import { Image } from "@heroui/react";
import { SupportedGames } from "@/types/game";

export function LeaderSquareWithBorder({
  leaderId,
  colors,
  image,
  size = 44,
  borderSize = 1,
  gameName = "one-piece",
}: {
  leaderId: string;
  colors?: string;
  image?: string;
  size?: number;
  borderSize?: number;
  gameName?: SupportedGames;
}) {
  let color1 = colors;
  let color2 = colors;

  if (!colors) {
    color1 = "transparent";
    color2 = "transparent";
  } else {
    if (colors.includes("/")) {
      color1 = colors.split("/")[0];
      color2 = colors.split("/")[1];
      color1 = getHexColor(color1);
      color2 = getHexColor(color2);
    } else {
      color1 = getHexColor(colors);
      color2 = getHexColor(colors);
    }
  }

  const outerSize = size;
  const innerSize = size - borderSize * 2;

  return (
    <div
      className="relative"
      style={{
        minWidth: `${outerSize}px`,
        minHeight: `${outerSize}px`,
        width: `${outerSize}px`,
        height: `${outerSize}px`,
      }}
    >
      {/* Rounded "Border" */}
      <div
        className="absolute inset-0 z-20 rounded-md"
        style={{
          background: `linear-gradient(to right, ${color1}, ${color2})`,
          opacity: ".7",
        }}
      ></div>

      {/* Centering Content with Flex */}
      <div className="h-full w-full relative inset-0 flex items-center justify-center">
        {/* Default Background */}
        <div
          className="absolute rounded-md bg-default-100 z-30"
          style={{
            width: `${innerSize}px`,
            height: `${innerSize}px`,
          }}
        ></div>

        {/* Image on Top */}
        <Image
          width={innerSize}
          height={innerSize}
          className="z-40 rounded-md"
          radius="sm"
          src={image || getLeaderSquare(leaderId, gameName)}
          alt=""
        />
      </div>
    </div>
  );
}

// function LeaderColors({ color }: { color: string }) {
//   let color1, color2;
//   let split = color.split("/");
//   if (split.length > 1) {
//     color1 = split[0];
//     color2 = split[1];
//   } else {
//     color1 = split[0];
//     color2 = split[0];
//   }

//   const colorMap = {
//     Red: "bg-red-500",
//     Blue: "bg-blue-500",
//     Green: "bg-green-600",
//     Purple: "bg-purple-400",
//     Black: "bg-slate-600",
//     Yellow: "bg-yellow-300",
//   };

//   // return <div>{color}</div>
//   return (
//     <div className="w-4 h-4 relative overflow-hidden rounded-full mr-4">
//       <div
//         className={`w-full h-full absolute ${colorMap[color1 as keyof typeof colorMap]}`}
//         style={{ clipPath: "polygon(0 0, 50% 0, 50% 100%, 0 100%)" }}
//       ></div>
//       <div
//         className={`w-full h-full absolute ${colorMap[color2 as keyof typeof colorMap]}`}
//         style={{ clipPath: "polygon(50% 0, 100% 0, 100% 100%, 50% 100%)" }}
//       ></div>
//     </div>
//   );
//   // return <div className="w-20 h-20 rounded-full bg-gradient-to-r from-green-500 to-yellow-500"></div>;
// }

function getHexColor(color: string) {
  switch (color) {
    case "Red":
      return "#f87171"; // same
    case "Green":
      return "#22c55e"; // more vibrant
    case "Blue":
      return "#60a5fa"; // same
    case "Purple":
      return "#8b5cf6"; // more vibrant
    case "Black":
      return "#737373"; // same
    case "Yellow":
      return "#f4e748"; // more vibrant (from #facc15)
    case "Orange":
      return "#f97316"; // vibrant orange
    default:
      return "transparent";
  }
}
